import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { ParlamentarianCreateEditState, ParlamentarianCreateEditReducer, ACTION_TYPES } from './parlamentarian-create-edit-reducer';
export { ACTION_TYPES };

const ParlamentarianCreateEditContext = createContext<ParlamentarianCreateEditState | undefined>(undefined);
const ParlamentarianCreateEditDispatchContext = createContext({} as any);

export const ParlamentarianCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { parlamentarianId } = useParams();
    const initialState: ParlamentarianCreateEditState = {
        parlamentarianId,
        parlamentarianRequest: { isActive: true },
        showValidationErrors: false,
    };
    const [state, dispatch] = useReducer(ParlamentarianCreateEditReducer, initialState);
    return (
        <ParlamentarianCreateEditContext.Provider value={state}>
            <ParlamentarianCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </ParlamentarianCreateEditDispatchContext.Provider>
        </ParlamentarianCreateEditContext.Provider>
    );
};

export const useParlamentarianCreateEditState = () => {
    const context = useContext(ParlamentarianCreateEditContext);
    if (!context) throw new Error('useParlamentarianCreateEditState must be used within ParlamentarianCreateEditProvider');
    return context;
};

export const useParlamentarianCreateEditDispatch = () => {
    const context = useContext(ParlamentarianCreateEditDispatchContext);
    if (!context) throw new Error('useParlamentarianCreateEditDispatch must be used within ParlamentarianCreateEditProvider');
    return context;
};
